<template>
  <div class="f-textarea-wrapper">
    <textarea
      :id="id"
      :aria-invalid="state === 'invalid'"
      :aria-required="required ? true : null"
      :disabled="disabled"
      :maxLength="maxLength"
      :name="name"
      :placeholder="placeholder"
      :readonly="readonly"
      :required="required"
      :rows="rows"
      :value="value"
      :class="{
        'f-textarea': true,
        'form-control': true,
        'is-valid': state !== 'invalid',
        'is-invalid': state === 'invalid',
        'full-width': fullWidth
      }"
      @input="onInput"/>
      <span
        v-if="maxLength"
        class="f-textarea-counter">
        {{ value && value.length ? value.length : 0 }} / {{ maxLength }}
      </span>
    </div>
</template>

<script>
export default {
  name: 'f-textarea',
  props: {
    id: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null
    },
    name: {
      type: String
    },
    placeholder: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    rows: {
      type: [Number, String],
      default: 4
    },
    showCounter: {
      type: Boolean,
      default: false
    },
    state: {
      type: [Boolean, String],
      default: null,
      validator: (v) => [null, 'valid', 'invalid', true, false].includes(v)
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.value);
    }
  }
}
</script>
